import { render, staticRenderFns } from "./refundOneDetail.vue?vue&type=template&id=7047d5a2&scoped=true&"
import script from "./refundOneDetail.vue?vue&type=script&lang=js&"
export * from "./refundOneDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundOneDetail.vue?vue&type=style&index=0&id=7047d5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047d5a2",
  null
  
)

export default component.exports